
import { defineComponent, PropType } from 'vue'
import ActiveUserMixin, { DashboardContext, SubscribedPlanInfo } from '~/mixins/activeUserMixin'
import { featureMap, FeatureProperties, FeatureType } from '~/types/features'
import { getRequiredPlanName } from '~/utils/billing'

export default defineComponent({
  name: 'PlanGateUpgradeState',
  mixins: [ActiveUserMixin],
  props: {
    feature: {
      type: String as PropType<FeatureType>,
      required: true
    },
    canChangePlan: {
      type: Boolean,
      required: true
    },
    planInfo: {
      type: Object as PropType<SubscribedPlanInfo>,
      default: () => ({})
    }
  },
  computed: {
    featureConfig(): FeatureProperties {
      return featureMap[this.feature]
    },
    planName(): string {
      return getRequiredPlanName(this.feature, this.planInfo)
    },
    isPersonalAccount(): boolean {
      const context = this.activeDashboardContext as DashboardContext
      return context?.type === 'user'
    }
  }
})
